import { QueryClient } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import Toaster from '../../Components/Toaster/Toaster';
const Toast = Toaster();
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000, // 5 minutes
      retry: 2,
    },
  },
});

export const commonAxiosError = () => {
  return (error: AxiosError<{ message: string }>) => {
    const message =
      (error?.response?.data?.message &&
        error?.response?.status !== 500 &&
        error?.response?.data?.message) ||
      'Something went wrong';
    Toast.fire({
      icon: 'error',
      title: message,
    });
  };
};
export const commonAxiosSuccess = (title?: string) => {
  return Toast.fire({
    icon: 'success',
    title: title || `Successfully Registered!`,
  });
};
